import React from "react";
import Button from 'react-bootstrap/Button';

/**
 * エラーレスポンスを変換し適切なエラーメッセージを返す
 * @param {*} responseData error.response.dataの中身
 * @returns エラーメッセージの配列
 */
export const formatErrorMessage = (responseData) => {
  // サーバーエラーなど
  if (typeof responseData === "string") {
    return [responseData];
  // クライアントエラー
  } else if (responseData.detail && !responseData.detail.errors) {
    return [responseData.detail];
  // CSVエラー
  } else if (responseData.detail && responseData.detail.detail && Array.isArray(responseData.detail.errors)) {
    return responseData.detail.errors.map((item, index) => {
      if (item.error.includes("こちらのテンプレート")) {
        const parts = item.error.split("こちら");
        return (
          <React.Fragment key={index}>
            {parts[0]}
            <Button
              variant="link"
              href="/manager/accuriodx_template.csv"
              download="accuriodx_template.csv"
              className="button-link-in-error p-0"
            >
              こちら
            </Button>
            {parts[1]}
          </React.Fragment>
        )
      } else {
        return <React.Fragment key={index}>{item.error}</React.Fragment>
      }
    })
  // それ以外
  } else {
    return ["問題が発生しました。"];
  }
}
